module.exports = __webpack_public_path__ + "img/banner-1.48189a0a.jpg";